<div class="today_chart_card">
    <mat-card>
    <div class="vier_tht">
       <div class="heading_ot">
       <h3>Expenditure </h3> 
      </div>
  </div>
  <div class="booking_chart" *ngIf="!loader && expenditureData.length > 0">
    <sm-line-chart-for-dashboard  [dataSource]="expenditureGraphData"></sm-line-chart-for-dashboard>
  </div> 
  <div class="placeholder_img_d" *ngIf="!loader && expenditureData.length == 0">
    <img src="../../../../../../../assets/images/chart-3.png" alt="Daily booking image"/>
   </div> 
</mat-card>
</div>
<!-- 
<div class="placeholder_cardf">
  <mat-card>
  <div class="vier_tht">
     <div class="heading_ot">
     <h3>Daily Sales </h3> 
    </div>
</div>
<div class="placeholder_img_d">
  <img src="../../../../../../../assets/images/chart-3.png" alt="Daily booking image"/>
</div>  
</mat-card>
</div> -->
